import React, { Fragment } from 'react';
import Message from 'src/shared/config/Message';

import getNetWorthOptions from './getNetWorthOptions';
import getSourceOfWealthOptions from './getSourceOfWealthOptions';
import getFieldOfWorkOptions from './getFieldOfWorkOptions';
import getPositionOptions from './getPositionOptions';
import getHearAboutUsOptions from './getHearAboutUsOptions';
import FieldTitle from '../components/FieldTitle';

import styles from '../styles.module.scss';

const Divider = () => (
    <div className={styles.divider}>
        <div className={styles.dividerLine} />
    </div>
);

const getStepThreeFields = (t, isInvestor) => {
    const fieldOfWorkOptions = getFieldOfWorkOptions(t);
    const netWorthOptions = getNetWorthOptions(t);
    const sourceOfWealthOptions = getSourceOfWealthOptions(t);
    const positionOptions = getPositionOptions(t);
    const hearAboutUsOptions = getHearAboutUsOptions(t);

    const basicFields = [
        {
            controlId: 'notReceiveUpdates',
            type: 'checkbox',
            label: <div className={styles.checkboxStatement}>{t('receive_update_statement')}</div>,
            className: styles.checkbox,
        },
        {
            controlId: 'email',
            type: 'custom',
            placeholder: '',
            // eslint-disable-next-line react/display-name
            renderer: ({ value }) => <input type="email" name="email" autoComplete="username" value={value} className="hide" readOnly />,
        },
    ];

    const additionalFields = isInvestor
        ? [
              {
                  controlId: 'fieldOfWork',
                  beforeRenderer: (
                      <Fragment>
                          <Divider />
                          <FieldTitle title={t('occupation')} />
                      </Fragment>
                  ),
                  type: {
                      name: 'dropdown',
                      options: fieldOfWorkOptions,
                      placeholder: t('field_of_work_prefill'),
                  },
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
                  value: '',
              },
              {
                  controlId: 'position',
                  type: {
                      name: 'dropdown',
                      options: positionOptions,
                      placeholder: t('position_prefill'),
                  },
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
                  value: '',
              },
              {
                  controlId: 'sourceOfWealth',
                  beforeRenderer: <FieldTitle title={t('major_of_wealth_prefill')} />,
                  type: {
                      name: 'dropdown',
                      options: sourceOfWealthOptions,
                      placeholder: t('major_of_wealth_prefill'),
                  },
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
                  value: '',
              },
              {
                  controlId: 'netWorth',
                  beforeRenderer: <FieldTitle title={t('liquid_net_worth_prefill')} />,
                  type: {
                      name: 'dropdown',
                      options: netWorthOptions,
                      placeholder: t('liquid_net_worth_prefill'),
                  },
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
                  value: '',
              },
              {
                  controlId: 'hearAboutUs',
                  beforeRenderer: (
                      <Fragment>
                          <Divider />
                          <FieldTitle title={t('register-ask-for-source')} />
                      </Fragment>
                  ),
                  type: {
                      name: 'dropdown',
                      options: hearAboutUsOptions,
                      placeholder: '',
                  },
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
                  value: '',
                  maxMenuHeight: 220,
              },
              {
                  controlId: 'referralEmail',
                  beforeRenderer: <FieldTitle title={t('register-referrers-email')} description={t('register-referrers-description')} />,
                  type: {
                      name: 'email',
                      placeholder: 'e.g. myfriend@altive.com',
                  },
                  validate: {
                      email: true,
                      message: t(Message.EMAIL_REQUIRED),
                  },
                  value: '',
              },
          ]
        : [
              {
                  controlId: 'organization',
                  beforeRenderer: <FieldTitle title={t('form_organization')} />,
                  label: t('form_organization'),
                  type: 'text',
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
              },
              {
                  controlId: 'title',
                  beforeRenderer: <FieldTitle title={t('form_title')} />,
                  label: t('form_title'),
                  type: 'text',
                  validate: {
                      required: true,
                      message: t(Message.FIELD_REQUIRED),
                  },
              },
          ];

    return basicFields.concat(additionalFields);
};

export default getStepThreeFields;
